import { createContext, useContext } from "react";
export const MarkdownStyleContext = createContext({
    textColor: "text-foreground",
    compactSpacing: false,
    canCopyQuotes: true,
});
export function useMarkdownStyle() {
    return useContext(MarkdownStyleContext);
}
//# sourceMappingURL=MarkdownStyleContext.js.map